import Navigation from './modules/Navigation';
import Breadcrumb from './modules/Breadcrumb';
import WPGallery from './modules/WPGallery';

// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

/* ACCORDEON FOOTER VERSION MOBILE */
const accordeonFooterMobiles = [].slice.call(document.querySelectorAll('.accordeon-footer li.accordeon-element'));
const accordeonContentFooterMobiles = [].slice.call(document.querySelectorAll('.accordeon-footer .uk-accordion-content'));

/* GET RESOLUTION / ADD MOBILE CLASS & DESKTOP CLASS  */
function getResolution() {
    if (window.screen.width <= 768) {
        // Resolution is 1024x768 or above
        document.querySelector('body').classList.toggle('mobile');
    } else {
        document.querySelector('body').classList.toggle('desktop');
    }
}
/* END */

const swiper = new Swiper('.swiper-container', {
    // Optional parameters
    direction: 'vertical',
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});

// CSS
import '../scss/styles.scss';


/* CONST NAV MOBILE  */
const menuBtn = document.querySelector('.btn-menu');
const containerNavMobile = document.querySelector('.kg-navigation');


/* NAV MOBILE FUNCTION  */
menuBtn.addEventListener('click', () => {
    var menuOpen = false;

    if (!menuOpen) {
        menuBtn.classList.toggle('open');
        containerNavMobile.classList.toggle('is-open');
        menuOpen = true;
    } else {
        menuBtn.classList.toggle('open');
        containerNavMobile.classList.toggle('is-open');
        menuOpen = false;
    }
});
/* END */


/* GESTION ACCORDEON NAV FOOTER  */
function accordeonFooter() {
    if (document.body.classList.contains('desktop')) {
        accordeonFooterMobiles.forEach(function(accordeonFooterMobile) {
            accordeonFooterMobile.classList.toggle('uk-open');
            accordeonContentFooterMobiles.hidden = false;
        });
    }
}
/* END */

/**
 * Back To Top
 */
const ButtonBackToTop = () => {
    const $button = document.querySelector('.uk-button-scroll');
    const windowHeight = window.innerHeight;

    if (!$button) {
        return false;
    }

    window.addEventListener('scroll', (e) => {
        if (document.documentElement.scrollTop >= windowHeight) {
            $button.classList.add('is-visible');
        } else {
            $button.classList.remove('is-visible');
        }
    });
};

/* RESIZE HEADER ON SCROLL */
function resizeHeaderOnScroll() {
    if (document.body.classList.contains('desktop')) {
        const distanceY = window.pageYOffset || document.documentElement.scrollTop,
            shrinkOn = 200,
            headerEl = document.getElementById('header');

        if (distanceY > shrinkOn) {
            headerEl.classList.add("smaller");
        } else {
            headerEl.classList.remove("smaller");
        }
    }
}

window.addEventListener('scroll', resizeHeaderOnScroll);

/* END */

/**
 * Init Function on document Ready
 */
const initReady = () => {
    // Défault
    const Nav = new Navigation();
    getResolution();
    Breadcrumb();
    ButtonBackToTop();
    accordeonFooter();
    resizeHeaderOnScroll();

    // Wordpress
    WPGallery();
    AOS.init({
        easing: 'ease-out-cubic',
        duration: 800,
        once: true
    });
};

// Document ready
document.addEventListener('DOMContentLoaded', initReady);